import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Dehumidifier Icon Style 03 - Dew Point (Material Symbol)
 */
export const Style03_Dew: React.FC<DeviceIconProps> = ({
  isOn = false,
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-teal-500' : 'text-slate-400';

  return (
    <span
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      dew_point
    </span>
  );
};

export default Style03_Dew;
